import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Alert, Snackbar } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../core/store';

const GeneralSettings: React.FC = () => {
  const [referralLink, setReferralLink] = useState<string | null>(null);
  const [phoneNumber, setPhoneNumber] = useState('(555) 123-4567');
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [newPhoneNumber, setNewPhoneNumber] = useState('');
  const [showCopiedAlert, setShowCopiedAlert] = useState(false);
  const [showPhoneUpdatedAlert, setShowPhoneUpdatedAlert] = useState(false);
  const basicInfo = useSelector((state: RootState) => state.basicInfo);
  const personalDetails = useSelector((state: RootState) => state.personalDetails);
  const [isLoading, setIsLoading] = useState(false);

  const generateReferralLink = async () => {
    setIsLoading(false);
  };

  const copyToClipboard = () => {
    if (referralLink) {
      navigator.clipboard.writeText(referralLink);
      setShowCopiedAlert(true);
    }
  };

  const shareReferralLink = () => {
    if (referralLink && navigator.share) {
      navigator
        .share({
          title: 'Join MindRight',
          text: 'Use my referral link to sign up for MindRight coaching!',
          url: referralLink,
        })
        .catch((err) => {
          console.error('Error sharing:', err);
        });
    } else {
      copyToClipboard();
    }
  };

  const handleEditPhone = () => {
    setNewPhoneNumber(phoneNumber);
    setIsEditingPhone(true);
  };

  const savePhoneNumber = () => {
    setPhoneNumber(newPhoneNumber);
    setIsEditingPhone(false);
    setShowPhoneUpdatedAlert(true);
  };

  const cancelEditPhone = () => {
    setIsEditingPhone(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant='h5' fontWeight={600} sx={{ mb: 4 }}>
        General Settings
      </Typography>

      {/* Phone Number Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' fontWeight={500} sx={{ mb: 2 }}>
          Phone Number
        </Typography>

        <Typography color='text.secondary' sx={{ mb: 2 }}>
          This is the number where you'll receive coaching messages
        </Typography>

        {isEditingPhone ? (
          <Box>
            <TextField
              fullWidth
              value={newPhoneNumber}
              onChange={(e) => setNewPhoneNumber(e.target.value)}
              placeholder='Enter phone number'
              sx={{ mb: 2 }}
              inputProps={{
                maxLength: 14,
              }}
            />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant='contained'
                color='primary'
                startIcon={<SaveIcon />}
                onClick={savePhoneNumber}
                sx={{
                  textTransform: 'none',
                  bgcolor: '#1a202c',
                  '&:hover': {
                    bgcolor: '#2d3748',
                  },
                }}
              >
                Save
              </Button>
              <Button
                variant='outlined'
                startIcon={<CancelIcon />}
                onClick={cancelEditPhone}
                sx={{ textTransform: 'none' }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='h6' sx={{ flexGrow: 1 }}>
              {basicInfo.phone}
            </Typography>
            {/* <Button
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={handleEditPhone}
              sx={{ textTransform: 'none' }}
            >
              Edit
            </Button> */}
          </Box>
        )}
      </Box>
      <Box sx={{ mb: 5 }}>
        <Typography variant='h6' fontWeight={500} sx={{ mb: 2 }}>
          Email
        </Typography>

        {/* <Typography color="text.secondary" sx={{ mb: 2 }}>
This is the number where you'll receive coaching messages
        </Typography> */}

        {isEditingEmail ? (
          <Box>
            <TextField
              fullWidth
              value={newPhoneNumber}
              onChange={(e) => setNewPhoneNumber(e.target.value)}
              placeholder='Enter phone number'
              sx={{ mb: 2 }}
              inputProps={{
                maxLength: 14,
              }}
            />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant='contained'
                color='primary'
                startIcon={<SaveIcon />}
                onClick={savePhoneNumber}
                sx={{
                  textTransform: 'none',
                  bgcolor: '#1a202c',
                  '&:hover': {
                    bgcolor: '#2d3748',
                  },
                }}
              >
                Save
              </Button>
              <Button
                variant='outlined'
                startIcon={<CancelIcon />}
                onClick={cancelEditPhone}
                sx={{ textTransform: 'none' }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='h6' sx={{ flexGrow: 1 }}>
              {personalDetails.email}
            </Typography>
            {/* <Button
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={handleEditEmail}
              sx={{ textTransform: 'none' }}
            >
              Edit
            </Button> */}
          </Box>
        )}
      </Box>

      {/* <Divider sx={{ my: 4 }} /> */}

      {/* Referral Section */}
      {/* <Box>
        <Typography variant="h6" fontWeight={500} sx={{ mb: 2 }}>
          Referral Link
        </Typography>

        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Share this link with friends to give them a free coaching session. You'll receive a free session when they sign up.
        </Typography>
        {referralLink ? (
          <Box>
            <Paper variant="outlined" sx={{ p: 2, mb: 3, borderRadius: 1 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                  <Typography
                    sx={{
                      wordBreak: 'break-all',
                      fontSize: '0.9rem',
                      color: 'primary.main'
                    }}
                  >
                    {referralLink}
                  </Typography>
                </Grid>
                <Grid item>
                  <IconButton onClick={copyToClipboard} size="small" color="primary">
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            </Paper>

            <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
                disabled={isLoading}
                loading={isLoading}
                variant="outlined"
                startIcon={<CachedIcon />}
                onClick={generateReferralLink}
                sx={{ textTransform: 'none' }}
              >
                Generate New Link
              </Button>  

              <Button
                variant="contained"
                color="primary"
                startIcon={<ShareIcon />}
                onClick={shareReferralLink}
                sx={{
                  textTransform: 'none',
                  bgcolor: '#1a202c',
                  '&:hover': {
                    bgcolor: '#2d3748'
                  }
                }}
              >
                Share Link
              </Button>
            </Box>
          </Box>
        ) : (
          <Button
            disabled={isLoading}
            loading={isLoading}
            variant="contained"
            color="primary"
            onClick={generateReferralLink}
            sx={{
              textTransform: 'none',
              bgcolor: '#1a202c',
              '&:hover': {
                bgcolor: '#2d3748'
              }
            }}
          >
            Generate Referral Link
          </Button>
        )}
      </Box> */}

      {/* Alerts */}
      <Snackbar
        open={showCopiedAlert}
        autoHideDuration={3000}
        onClose={() => setShowCopiedAlert(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setShowCopiedAlert(false)} severity='success' variant='filled'>
          Referral link copied to clipboard!
        </Alert>
      </Snackbar>

      <Snackbar
        open={showPhoneUpdatedAlert}
        autoHideDuration={3000}
        onClose={() => setShowPhoneUpdatedAlert(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setShowPhoneUpdatedAlert(false)} severity='success' variant='filled'>
          Phone number updated successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default GeneralSettings;
